import styled from "styled-components";


export const ConfirmationMessageWrap = styled.div`
  display: flex;
  margin:5px;
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 38px;
  }
  p{
    margin-bottom: 0px;
  }
`;

export const ConfirmationMessageImage = styled.img`
  margin-right: 20px;
`;

export const ConfirmationMessage = styled.div`
  font-family:  ${props => props.theme.fontFamily.helveticaNeueLight};
  font-size:${props => props.theme.fontSize.h4};
  letter-spacing:${props => props.theme.letterSpacing.normal};
  color:${props => props.theme.colors.secondaryColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
    letter-spacing:${props => props.theme.letterSpacing.heading};
    width: 273px;
  }
`;